import React from "react";
import {
  FaPhone,
  FaFacebook,
  FaLinkedin,
  FaInstagram,
  FaCopyright,
} from "react-icons/fa";
import { AiOutlineMail } from "react-icons/ai";
import { GoLocation } from "react-icons/go";
import Maps from "./google";
export const Contact = (props) => {
  return (
    <div>
      <div id="contact" className=" text-black mt-5">
        <div className="flex flex-col items-center justify-center">
          <h1 className="text-[#002e5b] py-4 ">Contact Us</h1>
          <h2 className="text-[#002e5b] md:py-4 md:px-0 xs:px-10 justify-center text-center ">
            Matrix Resources Limited is ready to supply and solve
          </h2>
          <h2 className="text-[#002e5b] py-1 ">your most complex challenges</h2>
        </div>
        <div className="flex items-center justify-center w-full">
          <div className="pt-10  items-center md:flex flex-col  justify-center w-full">
            {/* <div className="w-[200px] h-[100px]"><Maps/></div> */}

            <div className="p-2 flex ">
              <div className=" w-full">
                <a href="https://www.google.com/maps/place/Commodore+Office+Suites/@-1.2982931,36.7841304,17z/data=!3m1!4b1!4m6!3m5!1s0x182f109ec56d4431:0xdee2bf2039412201!8m2!3d-1.2982931!4d36.7867053!16s%2Fg%2F1ygb8n0pg?entry=ttu">
                  <img className="" src="/images/maps.jpg" alt="" />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className=" p-3 md:flex items-center justify-between gap-10 xs:px-[20px] md:px-[200px] bg-[#002e5b] mt-4 ">
          {/* <div>
            <h2 className="py-2 flex items-center text-white ">
              <FaCopyright /> &nbsp; Matrix Resources Ltd.
            </h2>
          </div> */}

          <div className="flex text-white items-center text-[17px] justify-center ">
            <FaPhone /> &nbsp; <h2>+254722276106</h2>
          </div>
          <div className="flex text-white items-center text-[17px] justify-center">
            <AiOutlineMail />
            &nbsp; <h2>@info.matrixresources.co.ke</h2>
          </div>
          <div>
            <h2 className="py-2 flex items-center text-white justify-center ">
              <FaCopyright /> &nbsp; Matrix Resources Ltd.
            </h2>
          </div>

          {/* <div className="flex gap-4 items-center">
            <button className="text-white">
              {" "}
              <FaFacebook />
            </button>
            <button className="text-white">
              {" "}
              <FaLinkedin />
            </button>
            <button className="text-white">
              {" "}
              <FaInstagram />
            </button>
          </div> */}
        </div>
      </div>
    </div>
  );
};
